const themeBaseDefs = {
    primaryBackgroundColor: 'Color: primary, background',
    primaryHoveredBackgroundColor: 'Color: primary, blendToBackground, 1050',
    raisedBackgroundColor: 'Color: background',
    raisedHoveredBackgroundColor: 'Color: background',
    // depressedBackgroundColor: 'Color: secondary, blendToBackground, 1000, 25',
    // depressedHoveredBackgroundColor: 'Color: secondary, blendToBackground, 1000, 50',
    raisedShadow: '0 1px 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.075)',
    raisedShadowHovered: '0 1.5px 3px rgba(0, 0, 0, 0.1), 0 3px 5px rgba(0, 0, 0, 0.075)',
    depressedShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), inset 0 2px 4px rgba(0, 0, 0, 0.025)',
    depressedShadowHovered: 'inset 0 1.5px 3px rgba(0, 0, 0, 0.1), inset 0 3px 5px rgba(0, 0, 0, 0.05)',
    floatingShadowXL: '0 16px 32px rgba(0, 0, 0, 0.1), 0 32px 64px rgba(0, 0, 0, 0.05)',
    floatingShadowL: '0 8px 16px rgba(0, 0, 0, 0.1), 0 16px 32px rgba(0, 0, 0, 0.05)',
    floatingShadowM: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.05)',
    floatingShadow1PropertiesM: '0 4px 8px',
    floatingShadow2PropertiesM: '0 8px 16px',
    floatingShadow1ColorM: 'Color: secondary, blendToBackground, 1000, 100',
    floatingShadow2ColorM: 'Color: secondary, blendToBackground, 1000, 50',
    floatingShadowS: '0 2px 4px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05)',
    floatingShadowXS: '0 1px 2px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.05)',
    // Border radius
    borderRadiusL: '12px',
    borderRadiusM: '8px',
    borderRadiusS: '6px',
    borderRadiusXS: '4px',
    // Form Elements
    formElementBackgroundColor: 'Color: secondary, blendToBackground, 1000, 40',
    formElementHoveredBackgroundColor: 'Color: secondary, blendToBackground, 1000, 60',
    formElementFocusedBackgroundColor: 'Color: background',
    formElementBorderColor: 'Color: secondary, blendToBackground, 1100, 75',
    formElementHoveredBorderColor: 'Color: secondary, blendToBackground, 1100, 125',
    formElementFocusedBorderColor: 'Color: primary, background',
    formElementOutlineWidth: '3px',
    formElementOutlineColor: 'Color: primary, blendToBackground, 1000, 150',
    formElementTextColor: 'Color: secondary, background',
    formElementFontSizeL: '16px',
    formElementFontSizeM: '14px', // Default
    formElementFontSizeS: '12px',
    formElementPlaceholderColor: 'Color: secondary, blendToBackground, 600',
    formElementHoveredPlaceholderColor: 'Color: secondary, blendToBackground, 800',
};
export const getThemeBase = (themeOverrides = {}) => {
    const themeDefs = {
        ...themeBaseDefs,
        ...themeOverrides,
    };
    return {
        ...themeDefs,
        // Buttons
        buttonFocussedOutline: themeDefs.formElementOutlineWidth,
        buttonPressedScale: '0.975',
        buttonDisabledOpacity: '0.5',
        buttonFontSize: '14px',
        buttonFontWeight: '500',
        buttonLineHeight: '16px',
        buttonLetterSpacing: '-.01em',
        buttonIconSize: '16px',
        buttonPadding: '12px var(--button-padding-x, 16px)',
        buttonPaddingIcon: '12px 17px 12px 15px',
        buttonPaddingIconRight: '12px 15px 12px 17px',
        buttonPaddingIconOnly: '10px',
        buttonGap: '4px',
        buttonBorderRadius: themeDefs.borderRadiusM,
        buttonFocussedOutlineColor: themeDefs.formElementOutlineColor,
        // Primary Buttons
        buttonPrimaryBackgroundColor: themeDefs.primaryBackgroundColor,
        buttonPrimaryHoveredBackgroundColor: themeDefs.primaryHoveredBackgroundColor,
        buttonPrimaryBackgroundInset: '0',
        buttonPrimaryBorderProperties: 'inset 0 0 0', // inset x y blur
        buttonPrimaryBorderColor: 'Color: secondary, blendToBackground, 1100, 75',
        buttonPrimaryBorderWidth: '1px',
        buttonPrimaryHoveredBorderProperties: 'inset 0 0 0',
        buttonPrimaryHoveredBorderColor: 'Color: secondary, blendToBackground, 1100, 125',
        buttonPrimaryHoveredBorderWidth: '1px',
        buttonPrimaryShadow: 'inset 0 -1px 0 rgba(0, 0, 0, 0.25), 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)',
        buttonPrimaryHoveredShadow: 'inset 0 -1px 0 rgba(0, 0, 0, 0.3), 0 1.5px 3px rgba(0, 0, 0, 0.25), 0 3px 5px rgba(0, 0, 0, 0.1)',
        // Secondary Buttons
        buttonSecondaryColor: 'Color: secondary, background',
        buttonSecondaryBackgroundColor: themeDefs.raisedBackgroundColor,
        buttonSecondaryHoveredBackgroundColor: themeDefs.raisedHoveredBackgroundColor,
        buttonSecondaryBackgroundInset: '1px',
        buttonSecondaryBorderProperties: '0 0 0',
        buttonSecondaryBorderColor: 'Color: secondary, blendToBackground, 1100, 75',
        buttonSecondaryBorderWidth: '1px',
        buttonSecondaryHoveredBorderProperties: '0 0 0',
        buttonSecondaryHoveredBorderColor: 'Color: secondary, blendToBackground, 1100, 125',
        buttonSecondaryHoveredBorderWidth: '1px',
        buttonSecondaryShadow: themeDefs.raisedShadow,
        buttonSecondaryHoveredShadow: themeDefs.raisedShadowHovered,
        buttonSecondaryOutlineBorderColor: themeDefs.formElementOutlineColor,
        // Button Subtle
        buttonSubtleFontWeight: 'var(--font-medium, 500)',
        // Button Small
        buttonSmallFontSize: '14px',
        buttonSmallFontWeight: '500',
        buttonSmallLineHeight: '16px',
        buttonSmallIconSize: '16px',
        buttonSmallPadding: '8px var(--button-padding-x-sm, 16px)',
        buttonSmallPaddingIcon: '8px var(--button-padding-x-sm, 16px) 8px var(--button-padding-x-sm, 14px)',
        buttonSmallPaddingIconRight: '8px var(--button-padding-x-sm, 14px) 8px var(--button-padding-x-sm, 16px)',
        buttonSmallPaddingIconOnly: '8px',
        buttonSmallGap: '4px',
        buttonSmallBorderRadius: themeDefs.borderRadiusM,
        // Button Tiny
        buttonTinyFontSize: themeDefs.formElementFontSizeS,
        buttonTinyFontWeight: '500',
        buttonTinyLineHeight: '16px',
        buttonTinyIconSize: '14px',
        buttonTinyPadding: '4px var(--button-padding-x-xs, 12px)',
        buttonTinyPaddingIcon: '4px 12px 4px 10px',
        buttonTinyPaddingIconRight: '4px 10px 4px 12px',
        buttonTinyPaddingIconOnly: '4px 5px',
        buttonTinyGap: '4px',
        buttonTinyBorderRadius: themeDefs.borderRadiusS,
        // Input
        inputFontSize: themeDefs.formElementFontSizeM,
        inputFontWeight: 'var(--font-regular, 400)',
        inputLineHeight: '16px',
        inputLetterSpacing: '0',
        inputPadding: '12px 16px',
        inputBorderRadius: themeDefs.borderRadiusM,
        inputFocussedBorder: '1px',
        inputFocussedBorderColor: themeDefs.formElementFocusedBorderColor,
        inputFocussedBackgroundColor: themeDefs.formElementFocusedBackgroundColor,
        inputFocussedOutline: themeDefs.formElementOutlineWidth,
        inputFocussedOutlineColor: themeDefs.formElementOutlineColor,
        inputErrorTextColor: 'Color: danger, background',
        inputErrorBackgroundColor: 'Color: background',
        inputErrorBorderColor: 'Color: danger, background',
        inputErrorPlaceholderTextColor: 'Color: danger, blendToBackground, 1000, 500',
        inputErrorHoveredPlaceholderTextColor: 'Color: danger, blendToBackground, 1000, 800',
        inputErrorOutlineColor: 'Color: danger, blendToBackground, 150',
        // Input Large
        inputLargeFontSize: themeDefs.formElementFontSizeL,
        inputLargeFontWeight: '400',
        inputLargeLineHeight: '20px',
        inputLargePadding: '12px 16px',
        inputLargeBorderRadius: themeDefs.borderRadiusM,
        // Input Default
        inputDefaultTextColor: themeDefs.formElementTextColor,
        inputDefaultBackgroundColor: themeDefs.formElementBackgroundColor,
        inputDefaultBorderColor: themeDefs.formElementBorderColor,
        inputDefaultPlaceholderTextColor: themeDefs.formElementPlaceholderColor,
        inputDefaultHoveredPlaceholderTextColor: themeDefs.formElementHoveredPlaceholderColor,
        inputDefaultHoveredBackgroundColor: themeDefs.formElementHoveredBackgroundColor,
        inputDefaultHoveredBorderColor: themeDefs.formElementHoveredBorderColor,
        // Input Small
        inputSmallFontSize: themeDefs.formElementFontSizeM,
        inputSmallFontWeight: 'var(--font-regular, 400)',
        inputSmallLineHeight: '16px',
        inputSmallPadding: '8px 12px',
        inputSmallBorderRadius: themeDefs.borderRadiusM,
        // Textarea
        textareaFontSize: themeDefs.formElementFontSizeM,
        textareaFontWeight: 'var(--font-regular, 400)',
        textareaLineHeight: '20px',
        textareaLetterSpacing: '0',
        textareaPadding: '12px 16px',
        textareaBorderRadius: themeDefs.borderRadiusM,
        textareaTextColor: 'Color: secondary, background',
        textareaBackgroundColor: themeDefs.formElementBackgroundColor,
        textareaPlaceholderTextColor: themeDefs.formElementPlaceholderColor,
        textareaHoveredPlaceholderTextColor: themeDefs.formElementHoveredPlaceholderColor,
        textareaHoveredBackgroundColor: themeDefs.formElementHoveredBackgroundColor,
        textareaBorderColor: themeDefs.formElementBorderColor,
        textareaHoveredBorderColor: themeDefs.formElementHoveredBorderColor,
        textareaFocussedBorder: '1px',
        textareaFocussedBorderColor: themeDefs.formElementFocusedBorderColor,
        textareaFocussedBackgroundColor: themeDefs.formElementFocusedBackgroundColor,
        textareaFocussedOutline: themeDefs.formElementOutlineWidth,
        textareaFocussedOutlineColor: themeDefs.formElementOutlineColor,
        textareaErrorTextColor: 'Color: danger, background',
        textareaErrorBackgroundColor: 'Color: background',
        textareaErrorBorderColor: 'Color: danger, background',
        textareaErrorPlaceholderTextColor: 'Color: danger, blendToBackground, 1000, 500',
        textareaErrorOutlineColor: 'Color: danger, blendToBackground, 1000, 150',
        // Textarea Small
        textareaSmallFontSize: themeDefs.formElementFontSizeM,
        textareaSmallFontWeight: 'var(--font-regular, 400)',
        textareaSmallLineHeight: '20px',
        textareaSmallPadding: '8px 12px',
        textareaSmallBorderRadius: themeDefs.borderRadiusM,
        // Dropdown
        dropdownButtonFontWeight: '500',
        dropdownMinWidth: '200px',
        dropdownBorderRadius: themeDefs.borderRadiusL,
        dropdownBorderProperties: '0 0 0',
        dropdownBorderWidth: '1px',
        dropdownBorderColor: 'Color: secondary, blendToBackground, 1100, 75',
        dropdownShadow: themeDefs.floatingShadowM,
        dropdownPaddingX: '4px',
        dropdownPaddingY: '4px',
        dropdownOffsetY: '4px',
        dropdownBackgroundColor: 'Color: background',
        dropdownArrowColor: 'Color: secondary, blendToBackground, 800',
        dropdownPlaceholderColor: themeDefs.formElementPlaceholderColor,
        dropdownErrorPlaceholderColor: 'Color: danger, blendToBackground, 800',
        dropdownEntryPadding: '12px',
        dropdownEntryPaddingSmall: '8px 12px',
        dropdownEntryBorderRadius: themeDefs.borderRadiusM,
        dropdownEntryColor: 'Color: secondary, background',
        dropdownEntrySecondaryColor: 'Color: secondary, blendToBackground, 600',
        dropdownEntryBackgroundColor: 'transparent',
        dropdownEntryLineHeight: '16px',
        dropdownEntryFontWeight: 'var(--font-medium, 500)',
        dropdownEntryFontSize: '14px',
        dropdownEntryGap: '8px',
        dropdownEntrySmallColor: 'Color: secondary, blendToBackground, 800',
        dropdownEntrySmallFontSize: '12px',
        dropdownEntrySmallLineHeight: '16px',
        dropdownEntryMargin: '0px',
        dropdownEntryFirstLastMargin: '0',
        dropdownEntryIconColor: 'Color: secondary, blendToBackground, 800',
        dropdownEntrySecondaryIconColor: 'Color: secondary, blendToBackground, 600',
        dropdownEntryIconSize: '16px',
        dropdownEntryBorder: '0px',
        dropdownEntryBorderColor: 'transparent',
        dropdownEntryHoveredColor: 'Color: secondary, background',
        dropdownEntryHoveredBackgroundColor: 'Color: secondary, blendToBackground, 75',
        dropdownEntryHoveredBorder: '0px',
        dropdownEntryHoveredBorderColor: 'transparent',
        dropdownEntryActiveColor: 'Color: secondary, background',
        dropdownEntryActiveBackgroundColor: 'Color: secondary, blendToBackground, 75',
        dropdownEntryActiveBorder: '0px',
        dropdownEntryActiveBorderColor: 'transparent',
        dropdownEntryActivePadding: '12px 40px 12px 12px',
        dropdownEntryActivePaddingSmall: '8px 40px 8px 12px',
        dropdownEntryActiveCheckmarkDisplay: 'block',
        dropdownEntryActiveCheckmarkRight: '16px',
        dropdownEntryActiveHoveredColor: 'Color: secondary, background',
        dropdownEntryActiveHoveredBackgroundColor: 'Color: secondary, blendToBackground, 75',
        dropdownEntryActiveHoveredBorder: '0px',
        dropdownEntryActiveHoveredBorderColor: 'transparent',
        dropdownEntryDangerBackgroundColor: 'transparent',
        dropdownEntryDangerColor: 'Color: danger, background',
        dropdownEntryDangerBorder: '0px',
        dropdownEntryDangerBorderColor: 'transparent',
        dropdownEntryDangerHoveredColor: 'Color: danger, background',
        dropdownEntryDangerHoveredBackgroundColor: 'Color: danger, blendToBackground, 50',
        dropdownEntryDangerHoveredBorder: '0px',
        dropdownEntryDangerHoveredBorderColor: 'transparent',
        // Geometry, colors and shadows mirror the @column/ui <Switch> (default size) so the legacy
        // <Toggle> reads identically while the ui-kit is phased out. Colors reference @column/ui's CSS
        // variables (loaded app-side via @column/ui/styles.css), with design-system hex fallbacks for
        // standalone contexts like this package's Storybook. themeVar() passes non-'Color:' strings
        // through as raw CSS, so var(...) here reaches styled-components untouched.
        toggleWidth: '32px',
        toggleHeight: '18px',
        toggleBorderRadius: '9999px',
        toggleBackgroundColor: 'var(--color-input, #E3E4E8)',
        toggleShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        toggleBorderColor: 'rgba(0, 0, 0, 0.1)',
        toggleBorderProperties: 'inset 0 0 0', // x y blur
        toggleBorderWidth: '1px',
        toggleDuration: '.2s',
        toggleEasing: 'cubic-bezier(0.2, 0.85, 0.32, 1.2)',
        toggleHoveredBackgroundColor: 'var(--color-input, #E3E4E8)',
        toggleHoveredBorderColor: 'rgba(0, 0, 0, 0.1)',
        toggleFocussedBackgroundColor: 'Color: primary, blendToBackground, 1000, 200',
        toggleFocussedBorderColor: themeDefs.formElementFocusedBorderColor,
        toggleFocussedOutline: themeDefs.formElementOutlineWidth,
        toggleFocussedOutlineColor: themeDefs.formElementOutlineColor,
        toggleCheckedBackgroundColor: 'var(--color-primary, #4575CD)',
        toggleCheckedHoveredBackgroundColor: 'var(--color-primary, #4575CD)',
        toggleCheckedFocussedOutlineColor: themeDefs.formElementOutlineColor,
        toggleCheckedBorderColor: 'transparent',
        toggleCheckedBorderProperties: 'inset 0 0 0', // x y blur
        toggleCheckedBorderWidth: '1px',
        toggleHandleSize: '14px',
        toggleHandleBorderRadius: '9999px',
        toggleHandleSpacing: '2px',
        toggleHandleShadow: '0 0 0 0.5px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.06)',
        // Kept theme-driven (not a --color-* var): resolves to a light thumb in both light and dark,
        // matching @column/ui's <Switch>, whereas --color-background would go dark in dark mode.
        toggleHandleBackgroundColor: 'Color: secondary, foreground',
        radioColor: 'Color: secondary, background',
        radioBackgroundColor: 'Color: background',
        radioGap: '8px',
        radioFontSize: '14px',
        radioLineHeight: '16px',
        radioFontWeight: 'var(--font-medium, 500)',
        radioSize: '16px',
        radioBorderRadius: '50%',
        radioBorderProperties: 'inset 0 0 0 1px rgba(0,0,0,0), inset 0 0 0',
        radioBorderWidth: '1px',
        radioBorderColor: 'Color: secondary, blendToBackground, 1000, 300',
        radioShadow: '0 0 0 1px rgba(0, 0, 0, 0), 0 1px 1px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0)',
        radioDuration: '.4s',
        radioEasing: 'cubic-bezier(0.2, 0.85, 0.32, 1.2)',
        radioHandleBackgroundColorTop: 'Color: primary, foreground',
        radioHandleBackgroundColorBottom: 'Color: primary, foreground',
        radioHandleShadow: themeDefs.raisedShadow,
        radioHandleScale: '0',
        radioHandleOpacity: '0',
        radioHandleSpacing: '4px',
        radioHandleSize: '8px',
        radioHandleBorderRadius: '50%',
        radioHoveredBackgroundColor: 'Color: background',
        radioHoveredBorderColor: 'Color: secondary, blendToBackground, 1000, 500',
        radioCheckedBackgroundColor: 'transparent',
        radioCheckedBorderProperties: 'inset 0 0 0 1px rgba(0,0,0,.2), inset 0 0 0',
        radioCheckedBorderWidth: '10px',
        radioCheckedBorderColor: themeDefs.formElementFocusedBorderColor,
        radioCheckedShadow: '0px 1px 1px rgba(38, 38, 44, 0.1), 0px 2px 4px rgba(38, 38, 44, 0.1)',
        radioCheckedHoveredBorderColor: 'Color: primary, blendToBackground, 1100',
        radioCheckedFocussedBorderColor: themeDefs.formElementOutlineColor,
        radioCheckedHandleScale: '1',
        radioCheckedHandleOpacity: '1',
        radioFocussedBorderColor: themeDefs.formElementFocusedBorderColor,
        radioFocussedOutline: themeDefs.formElementOutlineWidth,
        radioFocussedOutlineColor: themeDefs.formElementOutlineColor,
        checkboxBackgroundColor: 'Color: background',
        checkboxColor: 'Color: secondary, background',
        checkboxGap: '8px',
        checkboxFontSize: '14px',
        checkboxLineHeight: '18px',
        checkboxFontWeight: 'var(--font-medium, 500)',
        checkboxSize: '16px',
        checkboxBorderRadius: themeDefs.borderRadiusS,
        checkboxBorderProperties: 'inset 0 0 0 1px rgba(0,0,0,0), inset 0 0 0',
        checkboxBorderWidth: '1px',
        checkboxBorderColor: 'Color: secondary, blendToBackground, 1000, 300',
        checkboxShadow: '0 0 0 1px rgba(0, 0, 0, 0), 0 1px 1px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0)',
        checkboxDuration: '.4s',
        checkboxEasing: 'cubic-bezier(0.46, 0, 0, 1)',
        checkboxTickShadow: 'drop-shadow(0 3px 6px rgba(38 38 44 / 20%)) drop-shadow(0 1px 2px rgba(38 38 44 / 10%))',
        checkboxTickColor: 'Color: primary, foreground',
        checkboxHoveredBackgroundColor: 'Color: background',
        checkboxHoveredBorderColor: 'Color: secondary, blendToBackground, 1000, 500',
        checkboxFocussedBorderColor: themeDefs.formElementFocusedBorderColor,
        checkboxCheckedBackgroundColor: 'transparent',
        checkboxCheckedBorderProperties: 'inset 0 0 0 1px rgba(0,0,0,.2), inset 0 0 0',
        checkboxCheckedBorderWidth: '10px',
        checkboxCheckedBorderColor: themeDefs.formElementFocusedBorderColor,
        checkboxCheckedShadow: '0px 1px 1px rgba(38, 38, 44, 0.1), 0px 2px 4px rgba(38, 38, 44, 0.1)',
        checkboxCheckedHoveredBackgroundColor: 'Color: background',
        checkboxCheckedHoveredBorderColor: 'Color: primary, background',
        checkboxCheckedFocussedBorderColor: themeDefs.formElementFocusedBorderColor,
        checkboxFocussedOutline: themeDefs.formElementOutlineWidth,
        checkboxFocussedOutlineColor: themeDefs.formElementOutlineColor,
        checkboxCheckedFocussedOutlineColor: themeDefs.formElementOutlineColor,
        // Segmented Control
        segmentedControlBackgroundColor: 'Color: secondary, blendToBackground, 100',
        segmentedControlBorderColor: 'Color: secondary, blendToBackground, 1100, 75',
        segmentedControlShadow: themeDefs.depressedShadow,
        segmentedControlBorderWidth: '1px',
        segmentedControlBorderProperties: 'inset 0 0 0',
        segmentedControlBorderRadius: themeDefs.borderRadiusM,
        segmentedControlGap: '2px',
        segmentedControlPadding: '3px',
        // Small Segmented Control
        segmentedControlSmallBorderRadius: themeDefs.borderRadiusM,
        segmentedControlSmallGap: '2px',
        segmentedControlSmallPadding: '3px',
        // Tiny Segmented Control
        segmentedControlTinyBorderRadius: themeDefs.borderRadiusM,
        segmentedControlTinyGap: '2px',
        segmentedControlTinyPadding: '3px',
        // Segmented Control Option
        segmentedControlOptionBorderRadius: themeDefs.borderRadiusS,
        segmentedControlOptionActiveBackgroundColor: themeDefs.raisedBackgroundColor,
        segmentedControlOptionActiveShadow: themeDefs.raisedShadow,
        segmentedControlOptionColor: 'Color: secondary, blendToBackground, 700',
        segmentedControlOptionHoveredColor: 'Color: secondary, blendToBackground, 900',
        segmentedControlOptionActiveColor: 'Color: secondary, background',
        segmentedControlOptionHoveredBackgroundColor: 'Color: secondary, blendToBackground, 200',
        // Small Segmented Control Option
        segmentedControlSmallOptionPadding: '4px 12px',
        // Tiny Segmented Control Option
        segmentedControlTinyOptionPadding: '2px 8px',
        segmentedControlTinyOptionFontSize: '11px',
        segmentedControlTinyOptionFontWeight: '600',
        segmentedControlTinyOptionBorderRadius: themeDefs.borderRadiusS,
        // Chip
        // Chip Counter
        chipDefaultCounterGap: '8px',
        chipDefaultCounterPadding: '6px',
        chipSmallCounterGap: '6px',
        chipSmallCounterPadding: '4px',
        chipSmallCounterBorderRadius: themeDefs.borderRadiusS,
        chipLargeCounterGap: '8px',
        chipLargeCounterPadding: '6px',
        chipLargeCounterBorderRadius: themeDefs.borderRadiusS,
        // Chip Size: Default
        chipDefaultPadding: '4px 8px',
        chipDefaultPaddingIconOnly: '4px',
        chipDefaultFontSize: '12px',
        chipDefaultFontWeight: 'var(--font-medium, 500)',
        chipDefaultLineHeight: '14px',
        chipDefaultGap: '4px',
        chipDefaultBorderRadius: themeDefs.borderRadiusM,
        chipDefaultBorderWidth: '1px',
        chipDefaultBorderProperties: 'inset 0 0 0',
        chipDefaultIconSize: '16px',
        // Chip Size: Small
        chipSmallPadding: '4px 7px',
        chipSmallPaddingIconOnly: '4px',
        chipSmallFontSize: '12px',
        chipSmallFontWeight: 'var(--font-medium, 500)',
        chipSmallLineHeight: '14px',
        chipSmallGap: '4px',
        chipSmallBorderRadius: themeDefs.borderRadiusM,
        chipSmallBorderWidth: '1px',
        chipSmallBorderProperties: 'inset 0 0 0',
        chipSmallIconSize: '16px',
        // Chip Size: Large
        chipLargePadding: '6px 10px',
        chipLargePaddingIconOnly: '6px',
        chipLargeFontSize: '14px',
        chipLargeFontWeight: '500',
        chipLargeLineHeight: '16px',
        chipLargeGap: '4px',
        chipLargeBorderRadius: themeDefs.borderRadiusM,
        chipLargeBorderWidth: '1px',
        chipLargeBorderProperties: 'inset 0 0 0',
        chipLargeIconSize: '20px',
        // Chip Color: Default
        chipDefaultBackgroundColor: 'Color: secondary, blendToBackground, 1000, 75',
        chipDefaultTextColor: 'Color: secondary, background',
        chipDefaultBorderColor: 'Color: secondary, blendToBackground, 1000, 75',
        // Chip Color: Success
        chipSuccessBackgroundColor: 'Color: success, blendToBackground, 1000, 100',
        chipSuccessTextColor: 'Color: success, background',
        chipSuccessBorderColor: 'Color: success, blendToBackground, 1100, 75',
        // Chip Color: Warning
        chipWarningBackgroundColor: 'Color: warning, blendToBackground, 1000, 100',
        chipWarningTextColor: 'Color: warning, blendToBackground, 1200',
        chipWarningBorderColor: 'Color: warning, blendToBackground, 1200, 75',
        // Chip Color: Danger
        chipDangerBackgroundColor: 'Color: danger, blendToBackground, 1000, 100',
        chipDangerTextColor: 'Color: danger, background',
        chipDangerBorderColor: 'Color: danger, blendToBackground, 1100, 50',
        // Chip Color: Info
        chipInfoBackgroundColor: 'Color: primary, blendToBackground, 1000, 100',
        chipInfoTextColor: 'Color: primary, background',
        chipInfoBorderColor: 'Color: primary, blendToBackground, 1100, 50',
        // Tooltip
        tooltipBackgroundColor: 'Color: secondary, blendToForeground, 1000, 950',
        tooltipPadding: '12px',
        tooltipFontSize: '12px',
        tooltipFontWeight: 'var(--font-medium, 600)',
        tooltipDescriptionFontSize: '12px',
        tooltipLineHeight: '16px',
        tooltipBorderRadius: themeDefs.borderRadiusM,
        tooltipShadow: themeDefs.floatingShadowM,
    };
};
export const themeBase = getThemeBase();
//# sourceMappingURL=themeBase.js.map